import React from 'react'
import Particles from "react-tsparticles";
import { Container,Row,Col } from 'reactstrap';
import Header from '../Components/Navbar';
import Event from '../Components/Event';
import GlitchClip from 'react-glitch-effect/core/GlitchClip';
import tklogo from "../assets/tklogo.png"

const LiveEvents = ()=> {

    return (
        <div className="live">
             <Particles
                id="tsparticles"
                options={{
                background: {
                    color: {
                    value: "#0000",
                    },
                },
                fpsLimit: 60,
                
                particles: {
                    color: {
                    value: "#ffff",
                    },
                    links: {
                    color: "#ffff",
                    distance: 100,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                    },
                    collisions: {
                    enable: true,
                    },
                    move: {
                    direction: "none",
                    enable: true,
                    outMode: "bounce",
                    random: false,
                    speed: 2,
                    straight: false,
                    },
                    number: {
                    density: {
                        enable: true,
                        value_area: 1000,
                    },
                    value: 50,
                    },
                    opacity: {
                    value: 0.5,
                    },
                    shape: {
                    type: "circle",
                    },
                    size: {
                    random: true,
                    value: 3,
                    },
                },
                detectRetina: true,
                }}
            />
            <Header img={tklogo}></Header>
            <Container>
                <div className="live">
                    <div className="gbox">
                    <GlitchClip>
                    <h5 className="text-white title py-3">Live Events_</h5>
                    </GlitchClip>
                    </div>
                    <Row>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event
                            event="Meme Jedi"
                            rules={"> Participants must take part individually \n > The event will be conducted in a google meet in three rounds \n > Top 20 will be selected for the final round \n > Any sort of malpractice will be disqualified \n > Judges decision will be final "}
                            text={"The guardians of peace are back to tickle our funny bones and tackle the template to test them memes. Show us what you have in stock for in the end it’s all a rick roll anyways. May the memes be with you. "}
                            img= {require("../assets/live/meme.png")}
                            name="Sriram"
                            no="9677265902"
                            name1="ShiyamSundar"
                            no1="9629105054"
                            link="https://forms.gle/xijum3HdYMcyLFzG9"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Call Of Duty"
                            rules={"> Gaming should be done only on mobile phones \n > Emulators and Ipads are not allowed \n > All the members of the squad should register themselves in advance, Involvement of unregistered members will lead to instant elimination of the squad \n > Players should have all the maps downloaded prior to the event \n > Incase of any technical issues from the event organizer side is found, the match will be rescheduled. Participants are asked to agree with the new time allotted \n > Matches will be supervised by separate members to ensure unallowed behavior is not practiced"}
                            text={"Strategize to conquer. It's your call to take the glory. There is only one winner-the last man standing."}
                            img= {require("../assets/live/cod.png")}
                            name="Loganand"
                            no="8838796372"
                            name1="Sailesh"
                            no1="8667694265"
                            link="https://forms.gle/s5HtYeibs8p2BsPR7"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Secret Crisis"
                            rules={"> Quiz will be based on Marvel and DC movies \n > Participants must take part individually \n > Two rounds will be held on google meet with the help of Kahoot and buzzin.live \n > Top 8 will be shortlisted for the final round \n > Winners will be selected on the basis of maximum points scored \n > Any sort of malpractice will lead to disqualification"}
                            text={"Can you survive an onslaught of challenges caused due to the entanglement of the  two MARVELlously DarC universes? \n World’s greatest superheroes vs Earth’s mightiest heroes. One prevails. Test your might."}
                            img= {require("../assets/live/secretcrisis.png")}
                            name="Kavya"
                            no="6374253694"
                            name1="Rohith"
                            no1="9444552572"
                            link="https://forms.gle/zHG9ff6HkXMaBzEf9"
                            >
                        </Event>              
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Lights Out"
                            rules={"> Participants are asked to send their short films in registration form \n > Shortlisted films will be screened on the day of the event \n >  Controversial, sensitive and abusive contents are not encouraged \n > Judges decision will be final"}
                            text={"Give the director's touch and see the clutch. Unroll your imagination and restore the reality through the lenses. Imitate the art through the film and let the visuals speak volumes that words cannot."}
                            img= {require("../assets/live/lightsout.png")}
                            name="Janani"
                            no="9840603544"
                            name1="Saran"
                            no1="8925236404"
                            link="https://forms.gle/Y9dzsGoBzA2msX7r9"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Frame Spot"
                            rules={"> Participants must take part individually \n > Two rounds will be held on google meet with the help of Kahoot and buzzin.live \n > The difficulty increases with the level \n > Questions are exclusively from Kollywood/Tamil Movies \n > Winners will be decided based on the performance and scores"}
                            text={"Cinema is a matter of what's inside the frame and what's out!! When you see a movie you get the story but when you understand it you feel the story."}
                            img= {require("../assets/live/framespt.png")}
                            name="Kavya"
                            no="6374253694"
                            name1="ReehanRoshan"
                            no1="8778954039"
                            link="https://forms.gle/qoumCEdFsF9kcAha7"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Connexion"
                            rules={"> Participants must take part individually \n > Two rounds will be held on google meet with the help of Kahoot and buzzin.live \n > Top 8 will be shortlisted for the final round \n > Winners will be selected on the basis of maximum points scored \n > Any sort of malpractice will lead to disqualification"}
                            text={"The pictures speak more than you can tell ,so let your thoughts sail. Connect all dots and let the links be drawn , cause one wrong connection and it's all gone."}
                            img= {require("../assets/live/connextion.png")}
                            name="Kavya"
                            no="6374253694"
                            name1="Rohith"
                            no1="9444552572"
                            link="https://forms.gle/psnfh7BSo5sQmWx19"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2 offset-lg-2">
                        <Event 
                            event="Free Fire"
                            rules={"> Only solo participants are allowed \n > Game format : Battle Royale \n > Room id/code will be shared prior to the match \n > Results will be based on player analysis and kill percentage \n > All cheats and hacks are strictly forbidden \n > Treat players and organisers with respect. No form of toxicity will be tolerated \n > Exploiting glitches and bug abuse is not allowed"}
                            text={"Set foot on the battleground and load up your ammo. Obliterate your enemies to lead your team to victory!"}
                            img= {require("../assets/live/freefire.png")}
                            name="Loganand"
                            no="8838796372"
                            name1="Sailesh"
                            no1="8667694265"
                            cost={"₹20"}
                            link="https://forms.gle/vZjLDgsg32AfdFnd6"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Valorant"
                            rules={"> Participants should participate in a team of 5 \n > One registration per team \n > Participants can be from the same or different college \n > Registered team must have a discord account \n > Maps will be selected through lots \n > Matches will be conducted through knockout rounds \n > Incase of bug abuse or hacks the team will be disqualified \n > No spectators are allowed"}
                            text={"Run the riot!! \n You have 13 rounds to attack and defend your side using sharp gunplay and tactical abilities. If you want to survive and take out  your foes , you'll need to think faster than your opponent!"}
                            img= {require("../assets/live/Valorant.png")}
                            name="Loganand"
                            no="8838796372"
                            name1="Janeshwar"
                            no1="9952147275"
                            cost={"₹100 Per Team"}
                            link="https://forms.gle/dCQC4jwvgd8MuLUC6"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="Battle Of Rooks"
                            rules={"> Create an account on lichess app or through their website lichess.org \n >Should submit the screenshot of the Lichess account through the link provided in registration form \n > The duration of the game will be 90 minutes \n > The usage of chess engines or any other software is not allowed \n > If any found, the participant will be disqualified by the arbiter \n > Cash prizes will be awarded based on the analysis of your game"}
                            text={"Think out of the box but in the squares and plot your win to have the worthy king be the last one standing. May the odds be ever in your favor."}
                            img= {require("../assets/live/chess.png")}
                            name="Janani"
                            no="9840603544"
                            name1="Sneha"
                            no1="9489173462"
                            link="https://forms.gle/Z7njDjgtztCnPyYeA"
                            >
                        </Event>
                    </Col>
                    <Col md="3" xs="6" lg="2" className="my-2">
                        <Event 
                            event="60 to Victory"
                            rules={"> Video entries will be collected from participants while registering.Participants must take part individually \n > Participants will be shortlisted for the main event based on the entries sent \n > Any form of vulgarity will lead to immediate disqualification \n > Fillers must not be used \n > Topic will be given on-spot \n > No repetitive words or ideas \n > Objection by the judge is allowed \n > Participants must follow the general rules set by the judge while performing \n > The judge's decision will be final"}
                            text={"A minute might be good enough or not, to surf the sea or stand miserably. Get creative to influence. It's time to change the world in just a minute."}
                            img= {require("../assets/live/60tv.png")}
                            name="Kavya"
                            no="6374253694"
                            name1="Akshaya"
                            no1="6385603425"
                            link="https://forms.gle/D8FsNKvEgRQj18eP8"
                            >
                        </Event>
                    </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}
export default LiveEvents;